var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"object"},[_c('div',{staticClass:"object-rope"}),_c('div',{staticClass:"object-shape"},[_vm._v("Coming "),_c('span',{staticClass:"soon"},[_vm._v("Soon")])])])
}]

export { render, staticRenderFns }